import { useContext, useEffect, useState } from 'react';
import { UserContext } from '../Context/UserContext';
/* global gtag */

function SignupSuccess() {

  const [counter, setCounter] = useState(4);

  const { user } = useContext(UserContext);
  
  const isUserLoggedIn = user ? true : false;

  useEffect(() => {
    
    // Google Ads conversion action snippet.
    const conversionId = 'AW-17007525673/CudZCOuZuJobEKn-6K0_';

    // Check if gtag is available before trying to use it.
    if (typeof gtag === 'function') {
      console.log(`Firing conversion event for ${conversionId}`);
      gtag('event', 'conversion', {'send_to': conversionId});
    } else {
      console.error('gtag function not found. Google Ads may be blocked or not loaded.');
    }

    setInterval(() => {
      setCounter(counter => counter - 1);
    }, 1000);

    setTimeout(() => {
      window.location.href = `https://workspace.google.com/marketplace/app/table_invoice_ocr_for_google_sheets/687083288287`;
    }, 4000)

  }, []); 

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      fontFamily: 'sans-serif',
      textAlign: 'center',
      padding: '20px',
      backgroundColor: '#f8f9fa'
    }}>
      {/* Green Checkmark Icon */}
      <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="#4CAF50"/>
      </svg>
      
      <h1 style={{ marginTop: '20px', color: '#333' }}>Welcome, {user.name}! Your are all set.</h1>
      <p style={{ fontSize: '1.2em', maxWidth: '550px', color: '#555' }}>
        Redirecting to App Installation...
      </p>
      {counter>0 && <div>{counter}</div>}
    </div>
  );
}

export default SignupSuccess;